'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('menu-editor', {
      url: '/admin/menu-editor',
      template: '<menu-editor></menu-editor>',
      authenticate: 'admin'
    })
    .state('public-menu-editor', {
      url: '/admin/public-menu-editor',
      template: '<menu-editor public="true"></menu-editor>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/admin/menu/menu-editor.routes.js